import React from 'react'
import TalentAppStep from "../components/TalentAppStep";
import { Badge, Checkbox } from "antd";
import Form from "../../../components/form/Form";
import TaxClassSettingsForm from "../components/TaxClassSettingsForm";
import ReactDOM from "react-dom";
import User from "../../../models/User";
import { TalentAppCard } from '../components/TalentAppCard';

export default class WorkPreferencesStep extends TalentAppStep {
    static path = '/work-preferences';
    static LastUpdatedMethod = 'lastUpdatedWorkPreferences';

    static HasRequirements = true;
    /**
     * The title shown on the form
     */
    // static StepTitle = TB.trans('talent.recommended_skills.step_title');
    static StepTitle = 'Worker Classification';
    /**
     * The subtitle shown on the form
     */
    static StepSubtitle = (
        <span>
            Wripple offers a wide range of job opportunities including (a) short-term freelance projects, which are
            typically classified as 1099 or independent contractor assignments, and (b) longer-term staff augmentation
            roles which are typically classified as W2 or temp employee assignments. <b>Please confirm your interest in
                these two job types below.</b>
        </span>
    );

    /**
     * The start page info tile
     */
    static StepInfo = 'Worker Classification';

    /**
     * Show or hide review step info
     */
    static HideReview = true
    /**
     * The Step Section to be grouped in after application approval
     */
    static StepSection = 'Work Preferences';

    constructor(props) {
        super(props);
        this.nestedFormRefs = [React.createRef(), React.createRef()];
        this.state = { ...this.state };
    }

    /**
     * The step needed before editing
     */
    static StepNeedsValidation(user) {
        if (!user.validateWorkPreferences()) {
            return this;
        }

        return false;
    };

    /**
     * Check if we should prevent application from saving and show alert
     */
    static async getValidProps(user) {
        let {
            has_w2_classification,
            has_1099_classification,
            ...settings
        } = { ...(user.tax_class_settings || {} || {}) };

        if (!has_w2_classification && !has_1099_classification) {
            const node = ReactDOM.findDOMNode(document.querySelector('.talent-role-form'));

            if (node) {
                await $('html, body').animate({ scrollTop: $(node).offset().top }, 200);
                await TB.wait(400)
            }
            TB.toast("You must choose at least one tax classification", { theme: 'danger' });

            return false;
        }
        return user.validateWorkPreferences()
    };

    static hasCompleted(user) {
        return user.validateWorkPreferences();
    }

    async onChange(params) {
        let model = TB.pick(this.props.user, 'tax_class_settings') || {}
        for (let [key, value] of Object.entries(params)) {
            model = TB.set(model, key, value)
        }

        return super.onChange({ ...model });

    }

    async onW2Change(value) {
        return this.onChange({
            tax_class_settings: {
                ...(this.props.user?.tax_class_settings || {}),
                has_w2_classification: value
            }
        })
    }
    async on1099Change(value) {
        console.log('on1099Change', value);
        if (!this.props.disabled) {
            let {
                settings,
                has_1099_classification,
                has_w2_classification,
            } = {
                ...(this.props.user?.tax_class_settings || {}),
                has_1099_classification: value
            };
            let tax_class_settings = {
                ...settings,
                has_1099_classification,
                has_w2_classification
            };
            TB.map(TB.keys(settings), key => {
                delete tax_class_settings[key]
            })

            await this.nestedFormRefs?.[1].current?.forceReset({ tax_class_settings })

            await this.onChange({ tax_class_settings });

        }
    }

    /**
     * Render the form
     *
     * @returns {Form}
     */
    render() {

        let {
            has_1099_classification,
            has_w2_classification,
            ...settings
        } = { ...(this.props.user?.tax_class_settings || {}) }
        return (
            <div className="talent-application px-4 md:px-8 xl:w-10/12 w-full mr-auto ml-0">
                {this.renderTitle()}

                <TalentAppCard className="mb-6">
                    <div className="talent-role-form p-0 mb-0 [&_.form-container]:!p-0 [&_.field]:!p-0">
                        <Form
                            ref={this.nestedFormRefs?.[0]}
                            title={null}
                            subtitle={null}
                            showRequired
                            submitButton={false}
                            onChange={this.onChange.bind(this)}
                            model={TB.pick(this.props.user, ['tax_class_settings'])}
                            fields={[]}
                            isDisabled={this.props.disabled}
                        >
                            <TalentAppCard.Section>
                                <div className="form-title-section">
                                    <div className="step-title-content  px-0">
                                        <div>
                                            <h3 className="form-title">
                                                W2 Hourly Opportunities
                                            </h3>

                                        </div>
                                    </div>
                                </div>
                                <div className="field-section px-5">
                                    <div className="field px-4 flex flex-row items-start gap-5 justify-between">

                                        <Checkbox
                                            checked={has_w2_classification}
                                            onChange={e => this.onW2Change(e.target.checked)}>
                                            {has_w2_classification ? (
                                                <span className="text-lg font-medium text-black">
                                                    yes
                                                </span>
                                            ) : (
                                                <span className="opacity-30 text-lg font-medium">
                                                    yes
                                                </span>
                                            )}
                                        </Checkbox>
                                        <span className="flex-grow flex flex-col items-start justify-start gap-0.5">
                                            <span onClick={e => this.onW2Change(!has_w2_classification)}
                                                className="clickable flex flex-col items-start justify-start gap-0.5">
                                                <span>
                                                    I am interested in staffing assignments where I would be classified as a W2 hourly worker.
                                                </span>
                                                <span className="font-semibold">
                                                    Note: Most jobs available on Wripple are W2-based assignments.
                                                </span>
                                            </span>

                                            {/* <div className="mt-4 mb-3 flex flex-row items-center gap-3">
                                        <Badge count='W2 Worker' showZero
                                               color={has_w2_classification ? TB.config('color.success-dark') : TB.config('color.gray')}/>

                                        {has_w2_classification && (
                                            <div className="flex items-center flex-row gap-2">
                                            <i className="fas fa-arrow-right"/>
                                                <span className="text-sm italic">
                                                    Indicates you are qualified as a W2 worker
                                                </span>
                                            </div>
                                        )}
                                    </div> */}
                                            <div className="mt-3 border border-gray-950 py-3 px-6">
                                                <p className="font-semibold mb-2">
                                                    W-2 Hourly Workers:
                                                </p>
                                                <ul className="list-disc pl-5">
                                                    <li>
                                                        <b>Status:</b> Temp employees of Wripple's EOR partner.
                                                    </li>
                                                    <li>
                                                        <b>Taxes:</b> Taxes withheld by Wripple's EOR partner.
                                                    </li>

                                                    <li>
                                                        <b>Benefits:</b> May opt into health insurance <u><i>if project qualifies.</i></u>
                                                    </li>
                                                    <li>
                                                        <b>Type of Work:</b>
                                                        &nbsp;
                                                        Typically, longer term, embedded contractor roles where you are part of and take direction from the client's team
                                                    </li>
                                                </ul>

                                            </div>
                                        </span>
                                    </div>


                                </div>
                            </TalentAppCard.Section>
                        </Form>
                    </div>
                </TalentAppCard>

                <TalentAppCard>
                    <div className="talent-role-form mb-0 [&_.form-container]:!p-0 [&_.field]:!p-0">
                        <Form
                            ref={this.nestedFormRefs?.[1]}
                            title={null}
                            subtitle={null}
                            showRequired
                            submitButton={false}
                            onChange={this.onChange.bind(this)}
                            model={TB.pick(this.props.user, ['tax_class_settings'])}
                            fields={[]}
                            isDisabled={this.props.disabled}
                        >
                            <TalentAppCard.Section>
                                <div className="form-title-section">
                                    <div className="step-title-content px-0">
                                        <div>
                                            <h3 className="form-title">
                                                1099 Hourly Opportunities
                                            </h3>
                                        </div>
                                    </div>
                                </div>
                                <div className="field-section px-5">
                                    <div className="field px-4 flex flex-row items-start gap-5 justify-between">

                                        <Checkbox
                                            checked={has_1099_classification}
                                            onChange={e => this.on1099Change(e.target.checked)}
                                        >
                                            {has_1099_classification ? (
                                                <span className="text-lg font-medium text-black">
                                                    yes
                                                </span>
                                            ) : (
                                                <span className="opacity-30 text-lg font-medium">
                                                    yes
                                                </span>
                                            )}
                                        </Checkbox>
                                        <span className="flex-grow flex flex-col items-start justify-start gap-0.5">
                                            <span onClick={(e) => this.on1099Change(!has_1099_classification)}
                                                className="clickable">
                                                I am interested in freelance assignments where I would be classified as a 1099 worker (independent contractor)
                                            </span>
                                            <div className="my-3 border border-gray-950 py-3 px-6">
                                                <p className="font-semibold mb-2">
                                                    1099 Workers:
                                                </p>
                                                <ul className="list-disc pl-5">
                                                    <li>
                                                        <b>Status:</b> Independent contractors.
                                                    </li>
                                                    <li>
                                                        <b>Taxes:</b> Responsible for your own taxes.
                                                    </li>

                                                    <li>
                                                        <b>Benefits:</b> None.
                                                    </li>
                                                    <li>
                                                        <b>Type of Work:</b> Typically short-term, freelance style assignments for project-based work based upon your completion of specific deliverables.
                                                    </li>
                                                </ul>

                                            </div>
                                            <div
                                                className={!has_1099_classification ? "opacity-40 pointer-events-none mt-4" : " mt-4"}>
                                                <p className="mb-3">
                                                    <span className="font-semibold">Wripple 1099 Assessment.&nbsp;</span>
                                                    <span>
                                                        Please answer the 6 questions below to determine if you are likely to qualify as a 1099 worker for potential freelance assignments.
                                                    </span>
                                                </p>

                                                <div className="mt-4 mb-3 flex flex-row items-center gap-3">
                                                    <Badge count="1099 Worker" showZero
                                                        color={this.props.user.isQualifiedFor1099Classification() ? TB.config('color.success-dark') : TB.config('color.gray')} />

                                                    {this.props.user.isQualifiedFor1099Classification() ? (
                                                        <div className="flex items-center flex-row gap-2">
                                                            <i className="fas fa-arrow-right" />
                                                            <span className="text-sm italic">
                                                                Indicates you are qualified as a 1099 worker
                                                            </span>
                                                        </div>
                                                    ) : (has_1099_classification && (
                                                        <React.Fragment>
                                                            <div className="flex items-center flex-row gap-2">
                                                                <i className="fas fa-arrow-right" />
                                                                <span className="text-sm text-danger italic">
                                                                    {`${TB.filter(TB.keys(User.ClassificationQuestionsFor1099), key => settings[key] === true)?.length} out of ${TB.keys(User.ClassificationQuestionsFor1099).length} qualifications met`} as a 1099 worker
                                                                </span>
                                                            </div>
                                                            {/*<div className="flex items-center flex-row gap-2">*/}
                                                            {/*    <Badge className="badge-qualify"*/}
                                                            {/*           count={`${TB.filter(TB.keys(User.ClassificationQuestionsFor1099), key => settings[key] === true)?.length} out of ${TB.keys(User.ClassificationQuestionsFor1099).length} qualifications met`}*/}
                                                            {/*           showZero*/}
                                                            {/*           color={TB.config('color.warning')}/>*/}

                                                            {/*    <i className="far fa-info-circle"/>*/}
                                                            {/*    <span className="text-sm italic"></span>*/}
                                                            {/*</div>*/}
                                                        </React.Fragment>
                                                    ))}
                                                </div>

                                                <TaxClassSettingsForm isDisabled={!has_1099_classification} {...this.props} />
                                            </div>
                                        </span>
                                    </div>
                                </div>
                            </TalentAppCard.Section>
                        </Form>
                    </div>
                </TalentAppCard>
            </div>
        );
    }
    /**
     * Are requirements completed?
     *
     * @returns boolean
     */
    isRequirementComplete() {
        return this.props.authUser.tax_class_settings?.has_w2_classification || this.props.authUser.tax_class_settings?.has_1099_classification;
    }
    /**
     * Requirement messaging
     *
     * @returns string
     */
    requirementInfo() {
        return 'At least one work classification must be selected.';
    }

}

const styles = {
    fieldSection: {
        flexDirection: 'row'
    },
    field: {
        padding: '0 15px',
    },
};